/**
 * Global polyfills.
 */

/**
 * Overwrite default console function
 */
var disableConsole = function disableConsole() {

    if (window.console && window.WH.sportsbook.frontEndConfig.disableConsole) {

        // Keep reference to console, so it can be used to debug environments with disabled console
        window.consoleReference = window.console;

        window.console = {};

        window.console.log =
            window.console.debug =
                window.console.warn =
                    window.console.info =
                        window.console.assert =
                            window.console.error = function () {
                            };

    }
};

/**
 * Initialise things.
 * @returns {void}
 * @public
 */
var init = function () {
    disableConsole();
};

export default {
    init: init,
};
